TraceKit = require('tracekit')
TraceKit.remoteFetching       = false
TraceKit.collectWindowErrors  = true

config    = require('./config')
rollbar   = require('./rollbar')
reporter  = require('./reporter')

init = ->
  TraceKit.report.subscribe (errorReport, isWindowError, error) ->
    reporter.report(errorReport, isWindowError, error)

# ------------------------------------------------------------
module.exports =
  init:     init
  rollbar:  rollbar
  reporter: reporter
  config:   config
  TraceKit: TraceKit


// WEBPACK FOOTER //
// ./assets/js/shared/util/error/index.coffee